import { chainRoute } from 'atomic-router';
import { createEvent, createStore, sample } from 'effector';
import { createAction } from 'effector-action';
import { getShiftQuery, ShiftPersonal, ShiftTotal } from 'shared/api';
import { replace } from 'shared/lib';
import { authorizedShiftsRoute, authorizedGameRoute } from 'shared/routing';

const $shiftTotal = createStore<ShiftTotal | null>(null);

const $shiftPersonal = createStore<ShiftPersonal | null>(null);

const $shiftActive = $shiftTotal.map((shift) => shift?.isActive ?? false);

const shiftActivated = createEvent();

const replaceShiftsRoute = replace(authorizedShiftsRoute);

const checkShift = createAction({
	source: {
		shift: $shiftTotal,
		fetched: getShiftQuery.$finished,
	},
	target: {
		activate: shiftActivated,
		refresh: getShiftQuery.refresh,
		redirect: replaceShiftsRoute,
	},
	fn: (target, source) => {
		if (source.shift === null) {
			source.fetched ? target.redirect() : target.refresh();

			return;
		}

		source.shift.isActive ? target.activate() : target.redirect();
	},
});

sample({
	clock: getShiftQuery.finished.success,
	fn: ({ result }) => result,
	target: [$shiftTotal, $shiftPersonal],
});

sample({
	clock: getShiftQuery.finished.success,
	filter: authorizedGameRoute.$isOpened,
	target: checkShift,
});

const activatedGameRoute = chainRoute({
	route: authorizedGameRoute,
	beforeOpen: checkShift,
	openOn: shiftActivated,
});

export const shiftModel = {
	$shiftTotal,
	$shiftPersonal,
	$shiftActive,
	activatedGameRoute,
};
